import { Col, Input, Label, Row } from "reactstrap";
import { isEmpty } from "lodash";
import React from "react";

export function TabStepABusinessNameAndAddress({
  customerDetails,
  setCustomerDetails,

  toggleVerticalTab,
  activeVerticalTab,
}) {
  return (
    <>
      <div>
        <h5>Trading Name & Address</h5>
      </div>

      <Row className="g-3">
        <Col lg={12}>
          <div>
            <div className={"pt-4"}>
              <div htmlFor="company_name-field" className="form-label">
                Please select the type of business
              </div>
              <div>
                <input
                  type="radio"
                  className="btn-check"
                  name="transaction_type"
                  id="option2"
                  value={"1"}
                  checked={
                    customerDetails.CustomerSiteLocationBusinessType_Id === "1"
                  }
                  autoComplete="off"
                  onChange={() => {
                    setCustomerDetails({
                      ...customerDetails,
                      CustomerSiteLocationBusinessType_Id: "1",
                    });
                  }}
                />
                <label className="btn btn-success" htmlFor="option2">
                  Business
                </label>{" "}
                <input
                  type="radio"
                  className="btn-check "
                  name="transaction_type"
                  id="option1"
                  autoComplete="off"
                  checked={
                    customerDetails?.CustomerSiteLocationBusinessType_Id === "2"
                  }
                  value={"2"}
                  onChange={() => {
                    setCustomerDetails({
                      ...customerDetails,
                      CustomerSiteLocationBusinessType_Id: "2",
                    });
                  }}
                />
                <label className="btn btn-primary" htmlFor="option1">
                  Person
                </label>
              </div>
            </div>
          </div>
        </Col>
        {customerDetails?.CustomerSiteLocationBusinessType_Id && (
          <>
            {customerDetails?.CustomerSiteLocationBusinessType_Id === "1" && (
              <Col lg={12}>
                <div>
                  <Input
                    name="BusinessName"
                    id="BusinessName"
                    className="form-control"
                    placeholder={"Enter your Business Name"}
                    type="text"
                    onChange={(e) => {
                      setCustomerDetails({
                        ...customerDetails,
                        BusinessName: e.target.value,
                      });
                    }}
                    value={customerDetails?.BusinessName}
                  />
                </div>
              </Col>
            )}
            {customerDetails.CustomerSiteLocationBusinessType_Id === "2" && (
              <>
                <Col lg={4}>
                  <div>
                    <Input
                      name="PersonTitle"
                      id="PersonTitle"
                      className="form-control"
                      placeholder={"Your Title"}
                      type="text"
                      onChange={(e) => {
                        setCustomerDetails({
                          ...customerDetails,
                          PersonTitle: e.target.value,
                        });
                      }}
                      value={customerDetails?.PersonTitle}
                    />
                  </div>
                </Col>

                <Col lg={4}>
                  <div>
                    <Input
                      name="PersonFirstName"
                      id="PersonFirstName"
                      className="form-control"
                      placeholder={"First Name"}
                      type="text"
                      onChange={(e) => {
                        setCustomerDetails({
                          ...customerDetails,
                          PersonFirstName: e.target.value,
                        });
                      }}
                      value={customerDetails?.PersonFirstName}
                    />
                  </div>
                </Col>
                <Col lg={4}>
                  <div>
                    <Input
                      name="PersonLastName"
                      id="PersonLastName"
                      className="form-control"
                      placeholder={"Last Name"}
                      type="text"
                      onChange={(e) => {
                        setCustomerDetails({
                          ...customerDetails,
                          PersonLastName: e.target.value,
                        });
                      }}
                      value={customerDetails?.PersonLastName}
                    />
                  </div>
                </Col>
              </>
            )}

            <Col lg={6}>
              <div>
                <Input
                  name="AddressLine1"
                  id="AddressLine1"
                  className="form-control"
                  placeholder={"Enter First Line of Address"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressLine1: e.target.value,
                    });
                  }}
                  value={customerDetails?.AddressLine1}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <Input
                  name="AddressLine2"
                  id="AddressLine2"
                  className="form-control"
                  placeholder={"Enter Second Line of Address"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressLine2: e.target.value,
                    });
                  }}
                  value={customerDetails?.AddressLine2}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <Input
                  name="AddressLine3"
                  id="AddressLine3"
                  className="form-control"
                  placeholder={"Enter Third Line of Address"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressLine3: e.target.value,
                    });
                  }}
                  value={customerDetails?.AddressLine3}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <Input
                  name="AddressLine4"
                  id="AddressLine4"
                  className="form-control"
                  placeholder={"Enter Fourth Line of Address"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressLine4: e.target.value,
                    });
                  }}
                  value={customerDetails.AddressLine4}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <Input
                  name="AddressCity"
                  id="AddressCity"
                  className="form-control"
                  placeholder={"Enter City"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressCity: e.target.value,
                    });
                  }}
                  value={customerDetails.AddressCity}
                />
              </div>
            </Col>

            <Col lg={6}>
              <div>
                <Input
                  name="AddressCounty"
                  id="AddressCounty"
                  className="form-control"
                  placeholder={"Enter County"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressCounty: e.target.value,
                    });
                  }}
                  value={customerDetails.AddressCounty}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <Input
                  name="AddressPostCode"
                  id="AddressPostCode"
                  className="form-control"
                  placeholder={"Enter PostCode"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressPostCode: e.target.value,
                    });
                  }}
                  value={customerDetails.AddressPostCode}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <Input
                  name="AddressCountry"
                  id="AddressCountry"
                  className="form-control"
                  placeholder={"Enter Country"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressCountry: e.target.value,
                    });
                  }}
                  value={customerDetails.AddressCountry}
                />
              </div>
            </Col>
            <Col lg={12}>
              <div>
                <Input
                  name="SiteReference"
                  id="SiteReference"
                  className="form-control"
                  placeholder={"Enter Site Reference"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      SiteReference: e.target.value,
                    });
                  }}
                  value={customerDetails?.SiteReference}
                />
              </div>
            </Col>
          </>
        )}
      </Row>

      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-success btn-label right ms-auto nexttab nexttab"
          onClick={() => {
            toggleVerticalTab(activeVerticalTab + 1);
          }}
        >
          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          Contact information
        </button>
      </div>
    </>
  );
}
